module.exports = __webpack_public_path__ + "static/celebrate-c789690956ee2ef545ac85b2ac2d923a.svg";